// Configuration for external backend
// Use runtime config if available (for production), otherwise fall back to env var (for development)
export const API_BASE_URL = (typeof window !== 'undefined' && window.APP_CONFIG?.API_BASE_URL)
  ? window.APP_CONFIG.API_BASE_URL
  : (process.env.REACT_APP_API_BASE_URL || "https://smartcalluat.k8s.allence.cloud");

export const DEV_PHONE_IDENTITY = "dev-phone";
